module.exports = __webpack_public_path__ + "img/id.39e2c432.svg";